
























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class Topmain extends Vue {
  // items = [
  //   { src: "../../../assets/TopMain1.png" },
  //   { src: "../../../assets/TopMain1.png" },
  // ];
}
